import { Component } from "@theme/component";

/** Keeps a product's guarantee copy in sync with its selected native supply. */
class ProductPurchaseGuarantee extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.initialize();
  }

  initialize() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    const scope = this.closest(".shopify-section");
    if (!scope) return;
    try {
      this.ninetyDayVariants = JSON.parse(
        this.querySelector("[data-guarantee-variants]")?.textContent || "[]",
      ).map(String);
    } catch {
      return;
    }
    scope.addEventListener(
      "purchase:change",
      (event) => {
        if (
          event.target instanceof HTMLElement &&
          event.target.dataset.productId === this.dataset.productId
        ) {
          this.updatePeriod(event.detail?.variantId);
        }
      },
      { signal },
    );
    customElements.whenDefined("product-purchase-box").then(() => {
      if (signal.aborted || !this.isConnected) return;
      const controller = [
        ...scope.querySelectorAll("product-purchase-box"),
      ].find((element) => element.dataset.productId === this.dataset.productId);
      const variant = controller?.closest("form")?.querySelector('[name="id"]');
      if (variant) this.updatePeriod(variant.value);
    });
  }

  updatePeriod(variantId) {
    const period = this.ninetyDayVariants.includes(String(variantId))
      ? "90"
      : "30";
    if (this.dataset.activePeriod === period) return;
    for (const content of this.querySelectorAll("[data-guarantee-period]")) {
      const hidden = content.dataset.guaranteePeriod !== period;
      if (hidden) {
        content.querySelectorAll("purchase-dialog").forEach((dialog) => {
          dialog.closeDialog?.();
        });
      }
      content.hidden = hidden;
    }
    this.dataset.activePeriod = period;
  }

  disconnectedCallback() {
    this.abort?.abort();
    super.disconnectedCallback();
  }
}

if (!customElements.get("product-purchase-guarantee"))
  customElements.define("product-purchase-guarantee", ProductPurchaseGuarantee);
